import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import ArrayUtils from '../../../../../modules/ArrayUtils';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

class KCKTaxDetailedBill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { bill, } = this.props;
    const options = {};
    options.headerFormatter = object => _.startCase(object.header);

    const paymentTransactions = ObjectUtils.formatStringAsJSONArray(bill.paymentTransactions);
    const flatPmtTxns = ArrayUtils.selectivelyFlattenJSONArrayObjects(paymentTransactions);
    const paymentTransactionModel = Grid.toModelFromList(flatPmtTxns, options);
    const transactionReceipts = ObjectUtils.formatStringAsJSONArray(bill.transactionReceipts);
    const transactionReceiptsModel = Grid.toModelFromList(transactionReceipts, options);
    const enabledReminders = ObjectUtils.formatStringAsJSONArray(bill.enabledReminders);
    const lineItems = ObjectUtils.formatStringAsJSONArray(bill.lineItems);
    const flatLineItems = ArrayUtils.selectivelyFlattenJSONArrayObjects(lineItems);
    const lineItemsModel = Grid.toModelFromList(flatLineItems, options);
    const failedTransactions = ObjectUtils.formatStringAsJSONArray(
      bill.acknowledgedFailedTransactions
    );
    const failedTransactionsModel = Grid.toModelFromList(failedTransactions, options);

    const billItems = VerticalLabelList.toList({
      'External Account Id': bill.externalAccountId,
      TaxYear: bill.taxYear,
      'Statement Number': bill.statementNumber,
      'Due Date': moment(bill.dueDate).utc().format(),
      Paid: bill.isPaid,
      'ACH Failure': bill.achFailure,
      'Cash Only': bill.cashOnly,
      'Payment Plan': bill.paymentPlan,
      'Tax Sale': bill.taxSale,
      Bankruptcy: bill.bankruptcy,
      Delinquent: bill.delinquent,
      Protested: bill.protested,
      'Abate in Progress': bill.abateInProgress,
      'Informal Hearing': bill.informalHearing,
      'KS Setoff Program': bill.kansasSetoffProgram,
      'Is Heavy Truck': bill.isHeavyTruck,
      HB2427: bill.HB2427,
      'NSF Indicator': bill.nsfIndicator,
      'Bill Balance': bill.billBalance_value,
      'Client Bill Balance': bill.clientBillBalance_value,
      'PayIt Balance': bill.payItBalance_value,
      'Minimum Payment Amount': bill.minimumPaymentAmount_value,
      'Half Payment Amount': bill.halfPaymentAmount_value,
    });

    const propertyItems = VerticalLabelList.toList({
      'Property Type': bill.propertyTypeCode,
      'Parcel Number': bill.parcelNumber,
      'Taxpayer Name Id': bill.taxpayerNameId,
      'Taxpayer Name 1': bill.taxpayerName1,
      'Taxpayer Name 2': bill.taxpayerName2,
      'Owner Name Id': bill.ownerNameId,
      'Owner Name 1': bill.ownerName1,
      'Owner Name 2': bill.ownerName2,
      'Situs Address 1': bill.situsAddress1,
      'Situs Address 2': bill.situsAddress2,
      'Returned Mail': bill.returnedMail,
    });

    return (
      <div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Bill Summary">
            <VerticalLabelList
              items={billItems}
              className="column-2"
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Property Information">
            <VerticalLabelList
              items={propertyItems}
              className="column-2"
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Enabled Reminders" style={{ maxHeight: '200px', }}>
            <Grid
              headers={[ { value: 'enabledReminders', display: 'Enabled Reminders', }, ]}
              rows={enabledReminders.map(v => ({ value: [ v, ], raw: v, }))}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Failed Transactions" style={{ maxHeight: '200px', }}>
            <Grid
              headers={failedTransactionsModel.headers}
              rows={failedTransactionsModel.format(failedTransactions)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Payment Transactions" style={{ maxHeight: '200px', }}>
            <Grid
              headers={paymentTransactionModel.headers}
              rows={paymentTransactionModel.format(paymentTransactions)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Transaction Receipts" style={{ maxHeight: '200px', }}>
            <Grid
              headers={transactionReceiptsModel.headers}
              rows={transactionReceiptsModel.format(transactionReceipts)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Line Items" style={{ maxHeight: '200px', }}>
            <Grid
              headers={lineItemsModel.headers}
              rows={lineItemsModel.format(flatLineItems)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

KCKTaxDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default KCKTaxDetailedBill;
